import Axios from "../../configs/axios.config";

/* Folder */
export const createFolder = (data) => Axios.post(`/common/folders`, data);
export const updateFolder = (id, data) => Axios.put(`/common/folders/${id}`, data);
export const getFolders = (data) => Axios.get(`/common/folders`, { params: data }).then((res) => res.data);
export const deleteFolder = (id) => Axios.delete(`/common/folders/${id}`);
export const detailFolder = (id) => Axios.get(`/common/folders/${id}`).then((res) => res.data.data);
export const downloadFolder = (data) => Axios.get(`/common/folders/shared/download`, { params: data }).then((res) => res);

/* Folder */

/* File */
export const createFile = (data) => Axios.post(`/common/folders/upload-file`, data);
 
/* File */


/* Share Folder */
export const shareFolder = (data) => Axios.post(`/common/folders/share`, data);
export const shareUpdateFolder = (id, data) => Axios.put(`/gallery/folder/share/${id}`, data);
export const getShareFolders = (data) => Axios.get(`/common/folders/share`, { params: data }).then((res) => res.data);
export const deleteShareFolder = (id) => Axios.delete(`/gallery/folder/share/${id}`);
export const detailShareFolder = (id) => Axios.get(`/common/folders/share/${id}`).then((res) => res.data.data);